import React from "react";
import { css } from "@emotion/react";
import SparkleIcon from "@/svg/SparkleIcon";
import { gotham } from "@/utils/fonts";
import { mq } from "@/constants/breakpoints";
import Container from "../Container/Container";

interface PromotionalBannerProps {
  specialOffer?: {
    textBeforeAmount?: string;
    amountText: string;
    textAfterAmount?: string;
    amountColor?: string;
  };
}

export function PromotionalBanner({ specialOffer }: PromotionalBannerProps) {
  // Fallback values if no specialOffer is provided
  const beforeAmount = specialOffer?.textBeforeAmount || "Try any plan for";
  const amount = specialOffer?.amountText || "$19";
  const afterAmount =
    specialOffer?.textAfterAmount || "for the first month. No setup fees.";
  const amountColor = specialOffer?.amountColor || "#55d278";

  return (
    <div
      css={css`
        width: 100%;
        height: 62px;
        background-color: #243b4a;
        display: flex;
        align-items: center;
        justify-content: center;
      `}
    >
      <Container>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 6px;
            width: 100%;
            ${mq["lg"]} {
              gap: 14px;
            }
          `}
        >
          <div
            css={css`
              width: 36px;
              height: 36px;
            `}
          >
            <SparkleIcon />
          </div>
          <p
            css={css`
              color: white;
              font-size: 16px;
              font-weight: medium;
              margin: 0 8px;
              text-align: center;
            `}
            className={gotham.className}
          >
            {beforeAmount}{" "}
            <span
              css={css`
                color: ${amountColor};
              `}
            >
              {amount}
            </span>{" "}
            {afterAmount}
          </p>
          <div
            css={css`
              width: 36px;
              height: 36px;
            `}
          >
            <SparkleIcon />
          </div>
        </div>
      </Container>
    </div>
  );
}
